import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification } from "antd";
import { useNavigate, Link } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
  DeleteOutlined,
  EditOutlined,
  MinusCircleTwoTone,
  PlusCircleTwoTone,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
const ManageMCQ = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const [PageNumber, setPageNumber] = React.useState(1);
  const [Questionsets, setQuestionsets] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    QuestionnairesApi.ListQuestionset(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setQuestionsets(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    QuestionnairesApi.ListQuestionset(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setQuestionsets(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getQuestionset = useCallback(() => {
    QuestionnairesApi.ListQuestionset(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setQuestionsets(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getQuestionset(PageNumber);
    PageLoading();
  }, [getQuestionset]);

  const handleSubmit = (data) => {
    let singleLineString = quotations
      .map((obj) =>
        obj.answerType == "%"
          ? `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`
          : `${obj.title}${obj.answerType}${obj.name}`
      )
      .join("&");

    let filderData = window.btoa(
      
        "componentCode=QUESTION_SETS&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    console.log(filderData);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        console.log(response);
        PageLoading();
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setQuestionsets(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };

  const [pageSize, setPageSize] = useState(10);


  const handleDeleteQuestions = (QuestionsSetID) => {
    QuestionnairesApi.DeleteQuestionset(QuestionsSetID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getQuestionset(PageNumber);
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };
  const handleRemoveQuotation = (quotationIndex) => {
    const newQuotations = [...quotations];
    newQuotations.splice(quotationIndex, 1);
    setQuotations(newQuotations);
    if (quotationIndex == 0) {
      getQuestionset(PageNumber);
    }
  };

  const formRef = useRef(null);
  const handleClear = () => {
    PageLoading();
    getQuestionset(PageNumber);
    setQuotations([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const renderTableRows = () => {
    if (Questionsets.length > 0) {
      return Questionsets.filter((item) => item.isDelete === false)
        .reverse()
        .map((item) => (
          <tr key={item.id} className="text-center">
            <td>
              <Link
                to={`/masters/MCQ-management/view-MCQ?id=${item.id}`}
                className="textLink"
              >
                {item.questionSetsName}
              </Link>
            </td>
            <td className="text-center">{item.totalNumberOfQuestions}</td>
            <td className="text-center" style={{ width: "10%" }}>
              {item.passMark}
            </td>
            <td className="text-center" style={{ width: "10%" }}>
              {item.failMark}
            </td>
            <td className="text-center" style={{ width: "14%" }}>
              {item.priority}
            </td>
            <td style={{ width: "22%" }}>
              {" "}
              <div className="d-flex ">
                <Link
                  to={`/masters/MCQ-management/edit-MCQ?id=${item.id}`}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'EDIT_QUESTION_SETS'
                  ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
                >
                  <EditOutlined />
                  Edit
                </Link>
                <Popconfirm
                  title="Are you sure ?"
                  description="Do you really want to delete this action ?"
                  okText="Yes"
                  onConfirm={() => handleDeleteQuestions(item.id)}
                  placement="topRight"
                  className="w-100"
                  cancelText="No"
                >
                  <Link
                    to={``}
                    className={decodedToken?.permissions?.some(
                      (permission) => permission?.authority === 'DELETE_QUESTION_SETS'
                    ) ? 'btn btn-primary btn-back table-action icon-center' : 'd-none'}
                  >
                    <DeleteOutlined />
                    Delete
                  </Link>
                </Popconfirm>
              </div>
            </td>
          </tr>
        ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <EmptyBox />
            <br />
            <Link to={"/masters/MCQ-management/add-MCQ"}>
                  <Button
                    type="primary"
                    style={{
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                    Add new MCQ set
                  </Button>
                </Link>
          </td>
        </tr>
      );
    }
  };

  const [quotations, setQuotations] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddQuotation = () => {
    setQuotations([
      ...quotations,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const reloadForm = () => {
    if (formRef.current) {
      formRef.current.reset();
    }
  };
  const handleChangeTitle = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].title = value;
    setQuotations(newQuotations);
  };
  const handleChangeAnswertype = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].answerType = value;
    setQuotations(newQuotations);
  };

  const handleChangename = (quotationIndex, value) => {
    const newQuotations = [...quotations];
    newQuotations[quotationIndex].name = value;
    setQuotations(newQuotations);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {quotations.map((input, quotationIndex) => (
                    <div key={quotationIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${quotationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter by"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(quotationIndex, value)
                              }
                              options={[
                                {
                                  value: "questionSetsName",
                                  label: "Set Name",
                                },
                                {
                                  value: "priority",
                                  label: "Priority",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name={`type${quotationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(quotationIndex, value)
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item
                            name={`name${quotationIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(quotationIndex, e.target.value)
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {quotationIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddQuotation}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemoveQuotation(quotationIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>

        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {Questionsets.length > 0 && (
                  <div className="col-xl-12 col-lg-7 col-md-12 px-0 ">
                    {/* <Button
                      href={"/masters/MCQ-management/add-MCQ"}
                      className={decodedToken?.permissions?.some(
                        (permission) => permission?.authority === 'ADD_QUESTION_SETS'
                      ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                    >
                      Add new
                    </Button> */}
                    <Link to={"/masters/MCQ-management/add-MCQ"}>
                  <Button
                    type="primary"
                    style={{
                      height: "auto",
                      lineHeight: "normal",
                      alignItems: "center",
                      padding: "5px 24px",
                    }}
                  >
                    Add new MCQ set
                  </Button>
                </Link>
                  </div>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table MCQ-table">
              <thead>
                <tr>
                  <th>Set Name</th>
                  <th className="text-center">T.N of Question</th>
                  <th>Pass Mark</th>
                  <th className="text-center">Fail Mark</th>
                  <th className="text-center">Priority</th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {Questionsets.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default ManageMCQ;
